import { memo, useEffect } from 'react';
import Markup, { bodyClass } from './OfficerMarkup';
import { usePage, useLegacyController } from '../hooks/usePage';

const PageMarkup = memo(Markup);

export default function OfficerApp() {
  usePage({ title: 'Police Staff Duty App - Election Live Location', bodyClass });
  useLegacyController(() => import('../legacy/officer.js'));

  // status-bar clock of the simulated smartphone shell
  useEffect(() => {
    const tick = () => {
      const el = document.getElementById('phone-clock');
      if (el) el.textContent = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return <PageMarkup />;
}
